import { createSelector } from "reselect";

// Selectors
import { createFirstPageEventsForAssessmentAnswerGroupIdContextSelector } from "src/selectors/context_selectors/events_for_assessment_answer_group_id";
import { eventsResourceSelectors } from "src/selectors/data_selectors";

// Payload generator
import { createEventsGetPayload } from "src/api/events/payload_generators";

// Constants
import { eventTypeFilters } from "src/constants";

// Utils
import { buildQueryString } from "src/utils/build_query_string";

/**
 * create a selector to get the api query for the current page - loading events with a assessmentAnswerGroupId
 * @param {Object} props
 * @param {string} props.assessmentAnswerGroupId
 * @returns {function} selector
 */
export function createCurrentPageEventsForAssessmentAnswerGroupIdQuerySelector({
  assessmentAnswerGroupId
}) {
  return createSelector(
    eventsResourceSelectors.createCurrentPageForContextSelector(
      createFirstPageEventsForAssessmentAnswerGroupIdContextSelector({
        assessmentAnswerGroupId
      })
    ),
    pageNumber => {
      const queryParams = createEventsGetPayload({
        assessmentAnswerGroupId,
        pageNumber,
        eventType: eventTypeFilters.assessmentAnswerGroup
      });
      return buildQueryString(queryParams);
    }
  );
}
